import React from 'react'
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, IconButton } from '@material-ui/core';

import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';

const useStyles = makeStyles(theme => ({
    flexGrow: {
        flexGrow: 1
    },
    menu: {
        marginLeft: theme.spacing(1)
    },
    header: {
        width: 240,
        left: 0,
        right: 'auto'
    },
    logoImg: {
        height: 45
    }
}))
function SideBarHeader(props) {
    const { className, onClose, variantType, ...rest } = props;
    const classes = useStyles()
    return (
        <div>
            {variantType == 'temporary' ?
                <AppBar position="fixed" className={classes.header}>
                    <Toolbar>

                        <RouterLink to="/">
                            <img
                                src="/images/logos/drakto-5.svg"
                                alt="Logo"
                                className={classes.logoImg} />
                        </RouterLink>

                        <IconButton edge="start" color="inherit"
                            className={classes.menu}
                            onClick={onClose}>

                            <KeyboardArrowLeftIcon />

                        </IconButton>


                    </Toolbar>
                </AppBar>
                : null
            }
        </div>
    )
}

export default SideBarHeader
